// @ts-nocheck
import {reactive} from "vue"
import User from "../classes/User"


const user = reactive(new User())

export default user